export default "__VITE_ASSET__5793daf5__"